import React, { useEffect } from 'react'
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Card,
  CardContent,
  CardHeader,
  Button,
  Avatar,
  IconButton,
  Box,
} from '@mui/material'
import { PacmanLoader } from 'react-spinners'
import BlockUi from 'react-block-ui'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import Add from '@mui/icons-material/Add'
import { map } from '@/utils/lodash'
import LotDetailsForm from './LotDetailsForm'
import LotLoanForm from './LotLoanForm'
import ConstructionLoanForm from './ConstructionLoanForm'
import MezzanineLoanForm from './MezzanineLoanForm'
import InputSectionForm from './InputSectionForm'
import EndBuyerForm from './EndBuyerForm'
import TargetsSection from './TargetsSection'
import PerSqftTargetsSection from './PerSqftTargetsSection'
import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'

const EditLotDialog = ({
  open,
  onClose,
  loader,
  propertyLoading,
  lotPortfolioLoading,
  lotLoading,
  lotProcessesLoading,
  analysisInput,
  lotInput,
  propertyInput,
  assumptionsInput,
  lotProcessesInput,
  lotDetailFields,
  lotLoanFields,
  constructionLoanFields,
  mezzanineLoanFields,
  inputFields,
  endBuyerFields,
  lotTargetFields,
  PerSqftLotTargetFields,
  renderInputFields,
  createNewMezzanine,
  assumptions,
  analytics,
  netProfit,
  noFieldEmpty,
  handleClose2,
  setLoader,
  updateLot,
  open2,
  navigate,
}) => {
  useEffect(() => {
    console.log('[EditLotDialog] Rendered')
    console.log('[EditLotDialog] open:', open)
    console.log('[EditLotDialog] loader:', loader)
    console.log('[EditLotDialog] propertyLoading:', propertyLoading)
    console.log(
      '[EditLotDialog] lotPortfolioLoading:',
      lotPortfolioLoading,
    )
    console.log('[EditLotDialog] lotLoading:', lotLoading)
    console.log(
      '[EditLotDialog] lotProcessesLoading:',
      lotProcessesLoading,
    )
    console.log('[EditLotDialog] analysisInput:', analysisInput)
    console.log('[EditLotDialog] lotInput:', lotInput)
    console.log('[EditLotDialog] propertyInput:', propertyInput)
    console.log('[EditLotDialog] assumptionsInput:', assumptionsInput)
    console.log(
      '[EditLotDialog] lotProcessesInput:',
      lotProcessesInput,
    )
  }, [
    open,
    loader,
    propertyLoading,
    lotPortfolioLoading,
    lotLoading,
    lotProcessesLoading,
    analysisInput,
    lotInput,
    propertyInput,
    assumptionsInput,
    lotProcessesInput,
  ])

  return (
    <Dialog
      open={open}
      onClick={(event) => event.stopPropagation()}
      onContextMenu={(event) => event.stopPropagation()}
      onClose={onClose}
      onKeyDown={(e) => {
        if (e.key === 'Tab') e.stopPropagation()
      }}
      maxWidth="lg"
      fullWidth
    >
      <BlockUi
        blocking={
          loader ||
          propertyLoading ||
          lotPortfolioLoading ||
          lotLoading ||
          lotProcessesLoading ||
          !analysisInput ||
          Object.keys(analysisInput).length === 0
        }
        loader={
          <PacmanLoader color={'var(--primary)'} loading={true} />
        }
        message={
          <Box sx={{ color: '#368cff' }}>
            <p>{loader ? 'Updating Lot' : 'Loading'}</p>
          </Box>
        }
      >
        <DialogTitle style={{ padding: 15 }}>Edit Lot</DialogTitle>
        {propertyLoading ||
        lotPortfolioLoading ||
        lotLoading ||
        lotProcessesLoading ||
        !analysisInput ||
        Object.keys(analysisInput).length === 0 ? (
          <LoadingSkeleton variant="form" rowCount={8} />
        ) : (
          <DialogContent style={{ padding: 15 }}>
            <Grid container direction="row" spacing={1}>
              <Grid size={12}>
                <LotDetailsForm
                  lotDetailFields={lotDetailFields}
                  renderInputFields={renderInputFields}
                />
                <Divider
                  style={{
                    fontWeight: 600,
                    marginTop: 25,
                    marginBottom: 25,
                  }}
                />
                <LotLoanForm
                  lotLoanFields={lotLoanFields}
                  renderInputFields={renderInputFields}
                />
                <ConstructionLoanForm
                  constructionLoanFields={constructionLoanFields}
                  renderInputFields={renderInputFields}
                />
                <MezzanineLoanForm
                  analysisInput={analysisInput}
                  mezzanineLoanFields={mezzanineLoanFields}
                  renderInputFields={renderInputFields}
                  createNewMezzanine={createNewMezzanine}
                />
              </Grid>
              <InputSectionForm
                inputFields={inputFields}
                renderInputFields={renderInputFields}
              />
              <EndBuyerForm
                endBuyerFields={endBuyerFields}
                renderInputFields={renderInputFields}
              />
              <TargetsSection
                lotTargetFields={lotTargetFields}
                assumptions={assumptions}
                netProfit={netProfit}
                analytics={analytics}
              />
              <PerSqftTargetsSection
                PerSqftLotTargetFields={PerSqftLotTargetFields}
              />
            </Grid>
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={handleClose2} variant="text">
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={!noFieldEmpty}
            style={{ backgroundColor: '#ff3f3d', color: 'white' }}
            type="button"
            onClick={() => {
              setLoader(true)
              updateLot({
                variables: {
                  id: open2,
                  lotInput: { status: 'rejected' },
                },
              }).then(() => {
                setLoader(false)
                handleClose2()
              })
            }}
          >
            Reject
          </Button>
          <Button
            variant="contained"
            disabled={!noFieldEmpty}
            color="primary"
            type="button"
            onClick={() => {
              setLoader(true)
              updateLot({
                variables: {
                  id: open2,
                  lotInput: { status: 'approved' },
                },
                refetchQueries: [
                  {
                    query: 'GET_LOTS', // Should be imported and passed as prop if needed
                  },
                ],
              }).then(() => {
                setLoader(false)
                handleClose2()
                navigate('/' + open2 + '/editLot')
              })
            }}
          >
            Approve
          </Button>
        </DialogActions>
      </BlockUi>
    </Dialog>
  )
}

export default EditLotDialog
